import { MapPin, Check } from './Icons';

export default function Portfolio({ portfolio }) {
  const items = portfolio || [];
  if (items.length === 0) return null;

  return (
    <section className="section" id="work">
      <div className="container">
        <div className="section__head">
          <span className="eyebrow">Recent work</span>
          <h2 className="section__title">Deployments we&rsquo;re proud of</h2>
          <p className="section__sub">
            Real projects, delivered on spec — from single offices to multi-zone sites.
          </p>
        </div>

        <div className="grid grid--2">
          {items.map((p) => (
            <article key={p.slug || p.title} className="card work-card">
              <div className="work-card__banner" aria-hidden="true">
                <span className="work-card__tag">{p.category || 'project'}</span>
              </div>
              <div className="work-card__body">
                <h3 className="work-card__title">{p.title}</h3>
                <div className="work-card__meta">
                  {p.client && <span>{p.client}</span>}
                  {p.location && (
                    <span className="work-card__loc">
                      <MapPin width={14} height={14} /> {p.location}
                    </span>
                  )}
                </div>
                <p className="work-card__summary">{p.summary}</p>
                {Array.isArray(p.highlights) && p.highlights.length > 0 && (
                  <ul className="work-card__highlights">
                    {p.highlights.map((h) => (
                      <li key={h}>
                        <Check width={15} height={15} /> {h}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
